import { useTranslation } from 'react-i18next';
import type { TrendView } from './shared.js';

interface TrendViewSwitchProps {
  view: TrendView;
  onChange: (next: TrendView) => void;
}

/**
 * month / quarter の view を切替える pill segmented control。TeamTrendChart の右下に表示する。
 *
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business TeamTrendChart 内の view 切替 UI (月 / 四半期)
 * @graph-connects none
 */
export function TrendViewSwitch({ view, onChange }: TrendViewSwitchProps) {
  const { t } = useTranslation();
  const segClass = (active: boolean) =>
    `px-2.5 py-0.5 rounded-full text-[11px] font-semibold transition-colors leading-none ${
      active
        ? 'bg-[var(--color-bg-surface)] text-[var(--color-text-primary)] shadow-sm'
        : 'text-[var(--color-text-muted)] hover:text-[var(--color-text-primary)]'
    }`;
  return (
    <div
      className="inline-flex items-center gap-0.5 rounded-full p-0.5 border border-[var(--color-border)]"
      style={{ background: 'var(--color-bg-elevated)' }}
      role="group"
      aria-label="view switch"
    >
      <button
        type="button"
        onClick={() => {
          onChange('month');
        }}
        className={segClass(view === 'month')}
      >
        {t('idtKpi.teamTrend.viewMonth')}
      </button>
      <button
        type="button"
        onClick={() => {
          onChange('quarter');
        }}
        className={segClass(view === 'quarter')}
      >
        {t('idtKpi.teamTrend.viewQuarter')}
      </button>
    </div>
  );
}
